import _reduce from 'lodash/reduce';

export const getCombinedPageVariables = ({
  pageVariables,
  pageVariablesMethods,
}: {
  pageVariables: Record<string, unknown>;
  pageVariablesMethods: Record<string, unknown>;
}) => {
  return _reduce(
    pageVariablesMethods,
    (acc, pageVariableMethod, pageVariableId) => {
      const pageVariableValue = pageVariables[pageVariableId];
      acc[pageVariableId] = {
        value: pageVariableValue,
        ...(pageVariableMethod as Record<string, unknown>),
      };

      return acc;
    },
    {},
  );
};
